import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, depotStore } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DepotContext = createContext({ depots: [], depot: "", setDepot: () => {}, reload: async () => {}, version: 0, isAdmin: false, needsPick: false, showDepotTags: false, nameOf: () => "" });

// Which depot a supervisor is working in. Company logins switch freely ("" = All depots);
// depot logins are fixed to their own depot.
export const DepotProvider = ({ children }) => {
  const { user } = useAuth();
  const isCoord = user?.role === "coordinator";
  const isAdmin = isCoord && !!user?.is_company_admin;
  const [depots, setDepots] = useState([]);
  const [selected, setSelected] = useState(depotStore.get());
  const [version, setVersion] = useState(0);

  const setDepot = useCallback((id) => {
    depotStore.set(id);
    setSelected(id);
    setVersion((v) => v + 1);
  }, []);

  const reload = useCallback(async () => {
    if (!isCoord) { setDepots([]); return []; }
    try {
      const list = await api.depots();
      setDepots(list);
      const cur = depotStore.get();
      if (isAdmin && cur && !list.some((d) => d.id === cur)) setDepot("");
      return list;
    } catch { return []; }
  }, [isCoord, isAdmin, setDepot]);

  useEffect(() => { reload(); }, [reload, user?.id]);

  const depot = isAdmin ? selected : (user?.depot_id || "");
  const nameOf = useCallback((id) => depots.find((d) => d.id === id)?.name || "", [depots]);
  const value = {
    depots, depot, setDepot, reload, version, isAdmin, nameOf,
    needsPick: isAdmin && !selected && depots.length > 1,
    showDepotTags: isAdmin && !selected && depots.length > 1,
  };
  return <DepotContext.Provider value={value}>{children}</DepotContext.Provider>;
};

export const useDepot = () => useContext(DepotContext);
